<template>
  <div class="container-fluid page-container">
    <div class="row h-100">
      <div class="message__container d-flex m-auto">
        <div class="align-self-center">
          <h1 class="mb-0 pb-3 text-center font-weight-bold">
            {{ $t('Oops!') }}
          </h1>
          <div class="row">
            <div class="m-auto col-12">
              <hr class="m-auto pb-4 w-50">
              <h2 class="text-center pb-3 py-md-3">
                {{ $t('404 - Page not found') }}
              </h2>
            </div>
          </div>
          <i18n path="pageNotFound" tag="p" class="mt-2">
            <template #homeLinkText>
              <router-link :to="{name: 'dashboard'}" class="text-link text-reset">
                <span>{{ $t('homeLinkText') }}</span>
              </router-link>
            </template>
          </i18n>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound"
}
</script>

<style scoped lang="scss">
.page-container {
  min-height: 550px;
}

.message__container {
  @media screen and (min-width: 481px) {
    width: 404px;
  }
  @media only screen and (max-width: 480px) {
    max-width: 315px;
    padding: 15px;
  }
}

h1 {
  @include font-size(5.125rem);
}

p,
.text-reset {
  @include font-size($font-size-14);
}
</style>
